import { Component, Input, OnInit } from '@angular/core';
import { CallHistoryRecord, CallHistoryRecordType, NetWorkType } from '../../../core/services';


@Component({
  selector: 'app-call-direction-icon',
  template: `
    <div class="container">
    <i class={{iconClass}}></i>
    <i class="icon-small-whatsapp vox-text-aquamarine" *ngIf="isWhatsApp"></i>
    </div>
    `,
  styleUrls: ['./call-direction-icon.component.scss']
})
export class CallDirectionIconComponent implements OnInit {
  @Input() record: CallHistoryRecord;
  public callHistoryRecordType = CallHistoryRecordType;
  public iconClass: string;

  ngOnInit(): void {
    switch (this.record.type) {
      case CallHistoryRecordType.INCOMING_ANSWERED:
      case CallHistoryRecordType.INCOMING_ANSWERED_ELSEWHERE:
        this.iconClass = 'icon-small-call-inbound';
        break;
      case CallHistoryRecordType.OUTGOING_ANSWERED:
      case CallHistoryRecordType.OUTGOING_MISSED:
        this.iconClass = 'icon-small-call-outbound';
        break;
      case CallHistoryRecordType.INCOMING_MISSED:
        this.iconClass = 'icon-small-call-lost';
        this.iconClass += ' vox-text-bright-crimson';
        break;
      default:
        this.iconClass = '';  // Default case if needed
    }
  }

  public get isWhatsApp(): boolean {
    return this.record.networkType === NetWorkType.WHATSAPP;
  }
}